import { useState } from "react";
import { Info, Lightbulb, Hammer, FileSpreadsheet } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import { BocasTab } from "./BocasTab";
import { ManoObraTab } from "./ManoObraTab";
import { CatalogosExtTab } from "./CatalogosExtTab";

// Fix CC (2026-09-10): la BASE MADRE (CEN EAS, 10/09). Son las mismas pestañas que
// tiene el presupuesto, pero sin CatalogoPresupuestoContext: trabajan sobre las
// colecciones globales, igual que antes de este fix. Cada presupuesto nuevo arranca
// con una copia de esto; los que ya existen conservan la suya.
export function BaseMadrePanel() {
  const { user } = useAuth();
  const isProyectista = user?.role === "Proyectista";
  const [tab, setTab] = useState("bocas");
  const tabs = [
    ["bocas", "Bocas Eléctricas", Lightbulb],
    ["mo", "Mano de Obra", Hammer],
    // Mismo criterio que en el presupuesto: Proyectista no ve Catálogos.
    ...(isProyectista ? [] : [["catalogos", "Catálogos", FileSpreadsheet]]),
  ];

  return (
    <div className="flex flex-col min-h-full bg-gray-50" data-testid="base-madre-panel">
      <div className="flex items-start gap-2 mx-6 mt-4 bg-blue-50 border border-blue-200 rounded-xl px-4 py-2.5 text-xs text-[#1A4B7A]" data-testid="base-madre-aviso">
        <Info size={14} className="flex-shrink-0 mt-0.5" />
        <span>
          <b>Base madre.</b> Cada presupuesto nuevo arranca con una copia de lo que hay acá. Cambiar la base madre
          NO modifica los presupuestos que ya existen: cada uno conserva su copia, y desde sus pestañas se puede traer
          la base madre actual si hace falta.
        </span>
      </div>
      <div className="flex border-b border-gray-100 bg-white mt-3 px-6 overflow-x-auto">
        {tabs.map(([t, label, Icon]) => (
          <button key={t} onClick={() => setTab(t)}
            className={`flex items-center gap-1.5 px-4 py-3 text-sm font-semibold border-b-2 transition-colors whitespace-nowrap ${tab === t ? "border-[#2E6DA4] text-[#2E6DA4]" : "border-transparent text-gray-400 hover:text-gray-600"}`}
            data-testid={`base-madre-tab-${t}`}>
            <Icon size={14} /> {label}
          </button>
        ))}
      </div>
      {tab === "bocas" && <BocasTab />}
      {tab === "mo" && <ManoObraTab />}
      {tab === "catalogos" && !isProyectista && <CatalogosExtTab />}
    </div>
  );
}
